import React from 'react'
import AssessmentProgress from "../../assessment-progress"

export default function index(props) {
  const handleNext = () => {
    // Check if this is the last module
    if (props.isLastModule) {
      // Call the onComplete callback if provided
      if (props.onComplete) {
        props.onComplete();
      }
    } else if (props.nextPage) {
      // Otherwise continue to next module
      props.nextPage();
    }
  };

  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Great <span className="highlight1">Work!</span>
        </div>
        <div className="assessment1-content">
          {props.isLastModule 
            ? "Congratulations! You've completed all cognitive assessments. Click next to view your results."
            : "Click next to begin the next exercise to put your cognitive skills to the test!"}
        </div>

        <AssessmentProgress progress={props.progress} />

        <div onClick={handleNext} className="assessment1-start-btn">
          {props.isLastModule ? "View Results" : "Next"}
        </div>
      </div>
    </div>
  )
}
